import type { ResponseType } from '@/types/common';
import type { IssueField, IssueScheme } from '@/types/issue';
import httpUtil from '@/utils/http';
export * from './project';

const request = httpUtil.accurate.request;
const prefix = 'v1/issues';

export const issueSchemeApi = {
  /**
   * @description 获取所有方案
   */
  getAll(): ResponseType<IssueScheme[]> {
    return request({
      url: prefix + '/schemes',
      method: 'GET',
    });
  },

  /**
   * @description 创建新方案
   */
  create(data: IssueField): ResponseType {
    return request({
      url: prefix + '/scheme',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新方案
   */
  update(id: number, data: IssueField): ResponseType {
    return request({
      url: prefix + '/scheme/' + id,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除方案
   */
  del(id: number): ResponseType {
    return request({
      url: prefix + '/scheme/' + id,
      method: 'DELETE',
    });
  },

  /**
   * @description 获取方案配置
   */
  getConfig(schemeId: number): ResponseType {
    return request({
      url: prefix + '/scheme/' + schemeId + '/config',
      method: 'GET',
    });
  },

  /**
   * @description 创建方案配置
   */
  createConfig(data: any): ResponseType {
    return request({
      url: prefix + '/scheme/config',
      method: 'POST',
      data,
    });
  },

  /**
   * @description 更新方案配置
   */
  updateConfig(configId: number, data: any): ResponseType {
    return request({
      url: prefix + '/scheme/config/' + configId,
      method: 'PUT',
      data,
    });
  },

  /**
   * @description 删除方案配置
   */
  delConfig(configId: number): ResponseType {
    return request({
      url: prefix + '/scheme/config/' + configId,
      method: 'DELETE',
    });
  },

  /**
   * @description 获取方案字段
   */
  updateProjectScheme(schemeId: number, data: { projects: number[] }): ResponseType {
    return request({
      url: prefix + '/scheme/' + schemeId + '/configProject',
      method: 'POST',
      data,
    });
  },
};
